import { useContext } from 'react'
import { EditorViewContext } from '../EditorProviderContext'

export const useEditorView = () => {
  const context = useContext(EditorViewContext)

  if (!context) {
    throw new Error(`useEditorView is only available inside EditorProvider`)
  }

  return context
}
